import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import OperatingProceduresForm from "../../../../components/MainForm/OperatingProceduresForm";
import ItemStepDesService from "../../../../services/itemstepdes.service";

export default function EditOperatingProcedures() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [editData, setEditData] = useState({});

  const handleSubmit = ({ Des }) => {
    setLoading(true);
    ItemStepDesService.editItemStepDescriptions(id, Des.Array[0])
      .then((_) => {
        showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
        navigate("/wo_master/operating", { replace: true });
      })
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    ItemStepDesService.getItemStepDescriptions(id)
      .then((response) => setEditData(response))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Helmet>
        <title>แก้ไขขั้นตอนการปฏิบัติงาน</title>
        <meta name="description" content="Edit Operating Procedures Page" />
      </Helmet>

      <Container fluid className="p-3">
        <OperatingProceduresForm
          editData={editData}
          onSubmitCallback={handleSubmit}
        />
      </Container>
    </>
  );
}
